import type { ReactNode } from "react";
import { useEffect, useState } from "react";

import { ThemeContext } from "./active-theme-context";

const DEFAULT_THEME = "default";
const LOCAL_STORAGE_KEY = "active-theme";

export function ActiveThemeProvider({
	children,
	initialTheme,
	availableThemes = [],
}: {
	children: ReactNode;
	initialTheme?: string;
	availableThemes?: {
		name: string;
		className: string;
	}[];
}) {
	const [activeTheme, setActiveTheme] = useState<string>(
		() =>
			localStorage.getItem(LOCAL_STORAGE_KEY) || initialTheme || DEFAULT_THEME,
	);

	useEffect(() => {
		Array.from(document.body.classList)
			.filter((className) => className.startsWith("theme-"))
			.forEach((className) => {
				document.body.classList.remove(className);
			});
		document.body.classList.add(`theme-${activeTheme}`);
		if (activeTheme.endsWith("-scaled")) {
			document.body.classList.add("theme-scaled");
		}
	}, [activeTheme]);

	return (
		<ThemeContext
			value={{
				activeTheme,
				availableThemes,
				setActiveTheme: (theme: string) => {
					localStorage.setItem(LOCAL_STORAGE_KEY, theme);
					setActiveTheme(theme);
				},
			}}
		>
			{children}
		</ThemeContext>
	);
}
